import auth from '@/middleware/modules/auth'

const BoardsIndex = () => import(/* webpackChunkName: "_v-boards" */ '@/views/boards/BoardsIndex.vue')
const BoardEdit = () => import(/* webpackChunkName: "_v-boards" */ '@/views/boards/BoardEdit.vue')
const BoardView = () => import(/* webpackChunkName: "_v-boards" */ '@/views/boards/BoardView.vue')

export default [
  {
    path: 'boards',
    name: 'boards',
    props: (route) => ({ querySearch: route.query.search }),
    component: BoardsIndex,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
    },
  },
  {
    // { search: route.query.search, media_visible : route.query.media_visible, media_type : route.query.media_type, queries : route.query.queries}
    path: 'board/:id(\\d+)',
    name: 'board-view',
    component: BoardView,
    props: (route) => ({
      boardID: parseInt(route.params.id),
      querySearch: route.query.search,
      isPinsVisible: route.params.pins !== '0',
    }),
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['boards'],
    },
  },
  {
    path: 'board/new',
    name: 'board-new',
    component: BoardEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['boards'],
    },
  },
  {
    path: 'board/:id(\\d+)/edit',
    name: 'board-edit',
    component: BoardEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['boards'],
    },
  },
]
